import React from 'react';
import styled from 'styled-components';

interface CountBadgeProps {
  mediaItemsLength: number;
  modalSelectedImageIndex: number;
}

const CountBadgeContainer = styled.div`
  width: 68px;
  height: 32px;
  flex-shrink: 0;
  position: fixed;
  top: 1rem;
  left: 1rem;
  text-align: center;
  vertical-align: center;
  justify-content: center;
  align-items: center;
  display: flex;
  color: #000;
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.28px;
  text-transform: uppercase;

  z-index: 9999;
`;

const CountBadge: React.FC<CountBadgeProps> = ({
  mediaItemsLength,
  modalSelectedImageIndex,
}) => {
  return (
    <>
    <CountBadgeContainer className='count-badge'>
      {modalSelectedImageIndex + 1} / {mediaItemsLength}
    </CountBadgeContainer>
    </>
  );
};

export default CountBadge;
